import {Component, Vue} from "vue-property-decorator";
import iconInfo from "~/assets/inline-svg/icon_info_v2.svg?inline";

@Component
class ButtonInfo extends Vue {
  render(){
    return (
      <div class="icon icon--info" domPropsInnerHTML={iconInfo} />
    );
  }
}

export {ButtonInfo};

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-e29580b6/button-info.tsx" });